import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title: "Self Healing: \nAuto Remediation",
  subtitle: "Business Operations Demo",
  text: "Reduced lead time as well as a remarkable \nreduction in OPEX costs.",
  label: { iconPath: "start.png", text: "Error Management" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_114"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_112"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 10_R1.mp4",
  pageNumber: "ILO_113",
};

export default DATA_BO_DEMO_ILO1;
